// NATIVE 
import * as React from 'react';

// INSTALLED 
import { Link, useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import EditIcon from '@mui/icons-material/Edit';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import DeleteIcon from '@mui/icons-material/Delete';
import Menu, { MenuProps } from '@mui/material/Menu';
import { styled, alpha  } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { showNumberRowsTable } from '../../commons/utils/values';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Card, Chip, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, Pagination, Select, TablePagination, Toolbar, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../commons/theme';
import { hasPemissions, updateStatusRowTblPaginateRedux } from '../../commons/utils';
import { SnackAlert } from '../SnackAlert';
import { getCustomersByPagination, getCustomersByParamStore, getCustomersStore, setCustomersRedux, storeActiveCustomer, storeDesactiveCustomer, storeGetDetailCustomer } from '../../store/customer';
import { Restore } from '@mui/icons-material';
import { ClearIcon } from '@mui/x-date-pickers';


// CUSTOM 



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.secondary.contrastText,
    fontSize: 15,
    fontWeight: 700
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontWeight: 500,
    color: '#2e263de6'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));






/**
 * TableComponent is a React functional component that renders a table with customer data.
 * It includes features such as filtering, pagination, and actions for each customer.
 *
 * @component
 *
 * @example
 * return (
 *   <TableComponent />
 * )
 *
 * @returns {JSX.Element} The rendered TableComponent.
 *
 * @remarks
 * This component uses Redux for state management and React hooks for managing local state.
 * It also includes Material-UI components for styling and layout.
 *
 * @requires
 * - `useDispatch` from 'react-redux'
 * - `useNavigate` from 'react-router-dom'
 * - `useSelector` from 'react-redux'
 * - `React` from 'react'
 * - `styled` from '@mui/material/styles'
 * - `Menu`, `MenuItem`, `Button`, `Chip`, `Card`, `TableContainer`, `Paper`, `Toolbar`, `FormControl`, `InputLabel`, `Select`, `InputAdornment`, `IconButton`, `Divider`, `Table`, `TableHead`, `TableRow`, `TableBody`, `TablePagination`, `Box`, `Pagination` from '@mui/material'
 * - `ClearIcon`, `KeyboardArrowDownIcon`, `VisibilityIcon`, `EditIcon`, `DeleteIcon`, `Restore` from '@mui/icons-material'
 *
 * @param {Object} props - The props that are passed to the component.
 *
 * @state {boolean} alert_snack - State to control the visibility of the alert snackbar.
 * @state {string} message_alert_snack - State to control the message of the alert snackbar.
 * @state {string} type_alert_snack - State to control the type of the alert snackbar.
 * @state {string} filter - State to control the filter value.
 * @state {null | HTMLElement} openElem - State to control the currently open element.
 * @state {Array} dataTableList - State to control the list of data to be displayed in the table.
 * @state {Object} pagination - State to control the pagination details.
 * @state {null | HTMLElement} anchorEl - State to control the anchor element for the menu.
 * @state {number} rowsPerPage - State to control the number of rows per page.
 * @state {number} page - State to control the current page.
 * @state {number} pagePagination - State to control the current pagination page.
 * @state {number} itemCountPagination - State to control the item count for pagination.
 *
 * @function handleClick - Handles the click event for opening the menu.
 * @function handleClose - Handles the close event for closing the menu.
 * @function searchByFilter - Handles the search functionality based on the filter.
 * @function desactiveCustomer - Handles the deactivation of a customer.
 * @function activeCustomer - Handles the activation of a customer.
 * @function handleChangeRowsPerPage - Handles the change event for rows per page.
 * @function handleChangePage - Handles the change event for page.
 * @function changePaginationPage - Handles the change event for pagination page.
 * @function detalleCustomer - Handles the navigation to the customer detail page.
 * @function editarCustomer - Handles the navigation to the customer edit page.
 * @function getDataCustomers - Fetches the customer data.
 */
export const TableComponent = () => {


    // USE DISPATCH 
    const dispatch = useDispatch();


    // USE NAVIGATE 
    const navigate = useNavigate();


    // REDUX
    const  {  customers_list }:any  = useSelector( (state:any) => state.customer );


    // USE STATE 
    const [alert_snack, setAlertSnack] = React.useState(false);
    
    const [message_alert_snack, setMessageAlertSnack] = React.useState('');
    const [type_alert_snack, setTypeAlertSnack] = React.useState('success');

    const [filter, setFilter] = React.useState('');

   const [openElem, setOpenElem] = React.useState(null);

    const [dataTableList, setDataTable] = React.useState([]);
      const [pagination, setPagination] = React.useState<any>({
          "page": 1,
          "take": 1,
          "itemCount": 1,
          "pageCount": 1,
          "hasPreviousPage": false,
          "hasNextPage": false
      });
  

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(showNumberRowsTable);
    const [page, setPage] = React.useState(0);
    const [pagePagination, setPagePagination] = React.useState(1);
    const [itemCountPagination, setItemCountPagination] = React.useState(1);

    
    React.useEffect(() => {
          
      if ( customers_list.data && customers_list.data.length >= 0  ) {

        

        setDataTable(customers_list.data);
        setPagination({
          "page": customers_list.meta.page,
          "take": customers_list.meta.take,
          "itemCount": customers_list.meta.itemCount,
          "pageCount": customers_list.meta.pageCount,
          "hasPreviousPage": customers_list.meta.hasPreviousPage,
          "hasNextPage": customers_list.meta.hasNextPage
        });
        setItemCountPagination(customers_list.meta.pageCount);
      }
      

    }, [customers_list]);

   
    


  // CONST VALUE 
  const open = Boolean(anchorEl);
  

  // CONST FUNCTIONS 
  const handleClick = (elem:any) => (event:any) => {
    setAnchorEl(event.currentTarget);
    setOpenElem(elem);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenElem(null);
  };

  const searchByFilter = async(event:any) => {



                                              // permission_slug  // slug in childrens  // permission
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'view');
    
    
    if( !havePermissions ){

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');

      setTypeAlertSnack('error')

      return false;

                                                                    
        
    }


    const param = event.target.value;

    if (param == '') {
        return false;
    }
    
    if ( param != '' ) {
         setFilter(param);
    }

    let parametroSearch = 1;

    if  (param == 'activos') {
        parametroSearch = 1;
    }

    if  (param == 'vencidos') {
         parametroSearch = 2;
    }

    if  (param == 'inactivos') {
         parametroSearch = 0;
    }

    


    const response =  await dispatch( getCustomersByParamStore(parametroSearch) );
    
    
    if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');

      setTypeAlertSnack('error')

      return false;

    } 
    
     
  }

 



  const StyledMenu = styled((props: MenuProps) => (
    <Menu
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      {...props}
    />
  ))(({ theme }) => ({
    '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color:
        theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
        padding: '7px 0',
      },
      '& .MuiMenuItem-root': {
        '& .MuiSvgIcon-root': {
          fontSize: 18,
          color: theme.palette.text.secondary,
          marginRight: theme.spacing(1.5),
        },
        '&:active': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  }));
  


  const desactiveCustomer = async(customerId:string) => {

    // permission_slug  // slug in childrens  // permission
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'delete');


    if( !havePermissions ){

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( desactivar )  clientes.');

      setTypeAlertSnack('error')

      return false;                                           

    }


    const response = await dispatch( storeDesactiveCustomer(customerId) );


    if (response.ok) { 
   
        const result =  await updateStatusRowTblPaginateRedux(customers_list, customerId, 0 );

        if ( result?.ok ) {
            await  dispatch( setCustomersRedux(result.data) );
        }


    }


    if (!response.ok) {

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( desactivar ) clientes.');

      setTypeAlertSnack('error')

      return false;

    }

  }




  
  const activeCustomer = async(customerId:string) => {

    // permission_slug  // slug in childrens  // permission
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'restore');


    if( !havePermissions ){

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( activar )  clientes.');

      setTypeAlertSnack('error')

      return false;                                           

    }


    const response = await dispatch( storeActiveCustomer(customerId) );


    if (response.ok) { 
   
        const result =  await updateStatusRowTblPaginateRedux(customers_list, customerId, 1 );

        if ( result?.ok ) {
            await  dispatch( setCustomersRedux(result.data) );
        }


    }


    if (!response.ok) {

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( activar ) clientes.');

      setTypeAlertSnack('error')

      return false;

    }

  }




  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
  
     console.log('pajaro')
    setRowsPerPage(+event.target.value);

    setPage(0);
  };


  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  
  const changePaginationPage = async(event: React.ChangeEvent<unknown>, value: number) => {
    
    setPagePagination(value)

    const response =  await dispatch( getCustomersByPagination(value) );
    
    
    if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {

      setAlertSnack(true);

      await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');

      setTypeAlertSnack('error')

      return false;

    } 

  };


  const detalleCustomer = async(customerId: string) => {
 
      
      const customer = await dispatch( storeGetDetailCustomer(customerId) );

      if ( !customer.ok )  {
        
        setAlertSnack(true);

        await setMessageAlertSnack(customer.message);
  
        setTypeAlertSnack('error')
  
        return false;
      }


      navigate("/manager/clientes/detalle-cliente");


  }



  
  const editarCustomer = async(customerId: string) => {
 
      
    const customer = await dispatch( storeGetDetailCustomer(customerId) );

    if ( !customer.ok )  {
      
      setAlertSnack(true);

      await setMessageAlertSnack(customer.message);

      setTypeAlertSnack('error')

      return false;
    }


    navigate("/manager/clientes/editar-cliente");


  }



  const getDataCustomers = async() => {
  
      
                                               // permission_slug  // slug in childrens  // permission
      const havePermissions = await hasPemissions('modulo.manager', 'modulo.cliente',   'view');
      
      
          if( !havePermissions ){
      
            setAlertSnack(true);
  
            await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
  
            setTypeAlertSnack('error')
      
            return false;
      
                                                                          
              
          }
  
      
      const response =  await dispatch( getCustomersStore() );
  
      setFilter('');
      if ( !response.ok && response.statusCode == 403 || response.code && response.code == 403) {
  
        setAlertSnack(true);
  
        await setMessageAlertSnack('No tienes permisos para ( listar ) clientes.');
  
        setTypeAlertSnack('error')
  
        return false;
  
      }
  
    
  }
  
  return (

    <>

      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={message_alert_snack} severity={type_alert_snack}/>

      <Card
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          bgcolor: 'background.paper',
        }}
      >

    <TableContainer component={Paper} >
      
      <Toolbar>
        
          <FormControl sx={{ m: 1, minWidth: 120, width: '40%' }}>
            <InputLabel id="demo-simple-select-helper-label">Filtro por estado</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={filter}
              
              label="Filtro por estado"
              onChange={ (event) => searchByFilter(event) }
              endAdornment={
                filter.length > 0 && (
                  <InputAdornment sx={{ marginRight: "10px" }} position="end">
                    <IconButton
                      onClick={getDataCustomers}
                    >
                      <ClearIcon></ClearIcon>
                    </IconButton>
                  </InputAdornment>
                )
              }
            >
              <MenuItem value="">
                <em>Selecione un filtro</em>
              </MenuItem>
              <MenuItem value={'activos'}>Activos</MenuItem>
              <MenuItem value={'vencidos'}>Vencidos</MenuItem>
              <MenuItem value={'inactivos'}>Inactivos</MenuItem>
            </Select>
          </FormControl>

      </Toolbar>

      <Divider sx={{ marginBottom: 2, marginTop: 2 }}/>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
          <StyledTableCell>#</StyledTableCell>
            <StyledTableCell>Nombre</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>Nombre contacto</StyledTableCell>
            <StyledTableCell>Numero Contato ssss</StyledTableCell>
            <StyledTableCell>Estado</StyledTableCell>
            <StyledTableCell>Acciones</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
           { 
             dataTableList
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row:any, index) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell component="th" scope="row">
                {index + 1}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {row.name}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row" sx={{ color: 'gray'}} >
                {row.email}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {row.person_in_charge}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {row.contact}
              </StyledTableCell>

              <StyledTableCell component="th" scope="row">

                {
                  ( row.status == 0 ) && <Chip size='small' label="Inactivo" sx={{ color: '#FF4C51', background: '#FFE2E3', fontWeight: 700 }} />  
                }

                {
                  ( row.status == 1 ) && <Chip size='small' label="Activo" sx={{ color: '#5DCC0A', background: '#E4F6D6', fontWeight: 700 }} />  
                }

                {
                  ( row.status == 2 ) && <Chip size='small' label="Vencidos" sx={{ color: '#FFB911', background: '#FFF3D6', fontWeight: 700 }} />  
                }

                
              </StyledTableCell>
              
              {/* <StyledTableCell component="th" scope="row">
                <VisibilityIcon />
                <EditIcon />
                <DeleteIcon />
              </StyledTableCell> */}

              <StyledTableCell >  
             
              <div>
                <Button
                  id="demo-customized-button"
                  aria-controls={open ? 'demo-customized-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  variant="text"
                  disableElevation
                  onClick={handleClick(row)}
                  endIcon={<KeyboardArrowDownIcon />}
                >
                  Acciones
                </Button>
                <StyledMenu
                  id={`demo-customized-menu-${index+1}`}
                  MenuListProps={{
                    'aria-labelledby': `demo-customized-button-${index+1}`,
                  }}
                  anchorEl={anchorEl}
                  open={openElem === row}
                  onClose={handleClose}
                >


                  

                  {
                    ( row.status == 0 ) 
                      ? <div>
                        <MenuItem onClick={ () => activeCustomer(row.id) }  disableRipple>
                            <Restore />
                            Activar
                        </MenuItem> 
                      </div>
                      :
                      ''
                  }

                  {
                    ( row.status == 1 ) 
                      ? <div>             {/* component={Link} to={'/manager/clientes/detalle-cliente'} */}
                        <MenuItem onClick={ () => detalleCustomer(row.id) }   disableRipple>
                          <VisibilityIcon />
                          Detalle
                        </MenuItem>
                                          {/* component={Link} to={'/configuracion/compania/editar-compania'} */}
                        <MenuItem onClick={ () => editarCustomer(row.id) } disableRipple>
                          <EditIcon />
                            Editar
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem onClick={ () => desactiveCustomer(row.id) }  disableRipple>
                            <DeleteIcon />
                            Desactivar
                        </MenuItem> 
                      </div>
                      :
                      ''
                  }
                  
                </StyledMenu>
              </div>




              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    
    </Card>
    <TablePagination
      rowsPerPageOptions={[5, 10]}
      labelRowsPerPage={'Filas por pagina'}
      labelDisplayedRows={({ from, to, count }) => ` ${from}-${to} de  ${count} `}
      component="div"
      count={pagination.itemCount}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={ handleChangePage }
      onRowsPerPageChange={ handleChangeRowsPerPage }
    />
    
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: 2,
        marginBottom: 2
      }}
    >
     <Pagination sx={{ justifyContent: 'center' }} color="primary" count={itemCountPagination} page={pagePagination} onChange={ changePaginationPage} showFirstButton showLastButton />
    </Box>
    
    </>
    
  );
}


